import LayoutPage from "@/views/shared/LayoutPage";

export default [
  {
    path: "/materialMeasureType",
    component: LayoutPage,
    children: [
      {
        path: "",
        name: "materialMeasureType-page",
        component: () =>
          import("../../views/ProductMeasureType/ProductMeasureType.vue"),
        meta: {
          title: "Material Measure Type",
          titleLocalizationCode: "Material_Measure_Type",
          desc: "Material measure type page",
          descLocalizationCode: "Material_Measure_Type_Page",
          sidebarElement: false,
          permissionCodes: [
            "ProductMeasureType.Read",
            "ProductMeasureType.Add",
            "ProductMeasureType.Edit",
            "ProductMeasureType.Delete",
          ],
        },
      },
    ],
  },
];
